import { Card, CardHeader, CardBody, Text, Flex, Box, Link } from '@backstage/ui';
import { useEntity } from '@backstage/plugin-catalog-react';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../../core/i18n';
import {
  RiLinksLine,
  RiGlobalLine,
  RiGitRepositoryLine,
  RiBookOpenLine,
  RiDashboardLine,
  RiChat1Line,
  RiAlertLine,
  RiExternalLinkLine,
} from '@remixicon/react';
import { EmptyState } from '../../../../shared/components';
import styles from './links.module.css';

const getLinkIcon = (type?: string) => {
  switch (type?.toLowerCase()) {
    case 'website':
    case 'homepage':
      return <RiGlobalLine size={16} />;
    case 'repository':
    case 'repo':
      return <RiGitRepositoryLine size={16} />;
    case 'documentation':
    case 'docs':
      return <RiBookOpenLine size={16} />;
    case 'dashboard':
      return <RiDashboardLine size={16} />;
    case 'chat':
    case 'slack':
      return <RiChat1Line size={16} />;
    case 'monitoring':
    case 'alerting':
      return <RiAlertLine size={16} />;
    default:
      return <RiExternalLinkLine size={16} />;
  }
};

export const LinksCard = () => {
  const { entity } = useEntity();
  const { t } = useTranslationRef(appTranslationRef);

  const links = entity.metadata.links || [];

  return (
    <Card>
      <CardHeader>
        <Flex gap="3" align="center">
          <RiLinksLine size={18} className={styles.headerIcon} />
          <Text variant="title-small" weight="bold">
            {t('links.title')}
          </Text>
        </Flex>
      </CardHeader>
      <CardBody>
        {links.length === 0 ? (
          <EmptyState title={t('links.empty')} />
        ) : (
          <Flex direction="column" gap="3">
            {links.map((link, index) => (
              <Link
                key={index}
                href={link.url}
                target="_blank"
                className={styles.linkText}
              >
                <Flex
                  gap="3"
                  align="center"
                  className={styles.linkItem}
                >
                  <Box className={styles.linkIconWrap}>
                    {getLinkIcon(link.type)}
                  </Box>
                  <Flex direction="column" gap="0">
                    <Text variant="body-medium">
                      {link.title || link.url}
                    </Text>
                    {link.title && (
                      <Text variant="body-x-small" color="secondary" className={styles.linkUrl}>
                        {link.url}
                      </Text>
                    )}
                  </Flex>
                </Flex>
              </Link>
            ))}
          </Flex>
        )}
      </CardBody>
    </Card>
  );
};
